import { Component, TemplateRef, OnInit } from '@angular/core';
import { UserPage } from '../models/login';
import { ApiService } from '../Services/api-service';
import { UserMasterResponse, User, MyExcelData } from '../models/user';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/ngx-bootstrap-pagination';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from '../excel.service'
import * as moment from 'moment';
import { States, StateResponse } from '../models/State';
import { CityResponse, City } from '../models/city';
import * as XLSX from 'xlsx';
import { DealerMasterResponse } from '../models/dealer';
//import { Dealer, DealerMasterResponse } from '../models/dealer';
import { NgForm } from '@angular/forms';
import { ScanReport } from '../models/report';
type AOA = any[][];

interface Contractor {
  ContractorId: number;
  ContractorUsr: number;
  ContractorFirstName: string;
  ContractorEmail: string;
  ContractorMobile: string;
  ContractorPoints: number;
}

interface Dealer {
  salerName: any;
  SalesId: any;
  ContractorName: any;
  DealerName: any;
  SalerName: any;
  SalerId: any;
  ContractorPoints: any;
  DealerUsrGroup: any;
  ContractorUsrGroup: number; // Added
  ContractorFirstName: string; // Added
  ContractorEmail: string; // Added
  ContractorMobile: string; // Added
  ContractorId: any;
  DealerId: number;
  DealerUsr: number;
  DealerFirstName: string;
  DealerEmail: string;
  DealerMobile: string;
  Contractors: Contractor[];
}


@Component({
  selector: 'app-dealerwisecontractor',
  templateUrl: './dealerwisecontractor.component.html',
  styleUrls: ['./dealerwisecontractor.component.css']
})



export class DealerwisecontractorComponent implements OnInit {
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];

  groupedDealers: any[] = [];
  reportExcelPassbook: any[] = [];
  pagesUser: UserPage = new UserPage();
  users: Dealer[] = [];
  //formval: Dealer = new Dealer();
  show: boolean = false;
  modalhead: string = "Upload Dealer Details";
  dnm: boolean = false;
  result: string = "0"
  totaldata: number;
  activate: string = "done"
  numberedit: string = "";
  data1: any = [];
  data: AOA = [];
  templateDealer: MyExcelData[] = [];
  template: TemplateRef<DealerwisecontractorComponent>;
  modalRef: BsModalRef;
  errorList: User[] = [];
  modalRef2: BsModalRef;
  modalRef3: BsModalRef;
  modalRef4: BsModalRef;
  states: States[] = [];
  mobileReg: RegExp = /^[6-9]\d{9}$/;
  emailReg: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  isEdit: boolean = true;
  cities: City[] = [];
  SuccessCount: string = "0"
  ErrorCount: string = "0";
  currentPage: number;
  dealerlist: Dealer[] = [];
  buttonText: string = "Save";
  DeleteId: number;
  IsActive: boolean;
  DealerId: number;
  scanreportlistexcel: ScanReport[] = [];
  ContractorFirstName: number;
  ContractorId: number;
  ContractorMobile: number;

  fromDate: string; // Add fromDate property
  toDate: string; // Add toDate property
  formval: any = { PageSize: 10, Page: 1, fromdate: '', todate: '', SearchValue: '' }; // Add formval property
  settingslist: null;


  constructor(private excelService: ExcelService, private toastr: ToastrService, private apiService: ApiService, private modalService: BsModalService) {
    this.pagesUser.Filter = '';
  }
  ngOnInit() {
    //this.getDealerList();
    //this.getDealerContractors();
    this.getDealerWiseContractorReport(this.formval.Page, this.formval.PageSize, this.fromDate, this.toDate, this.formval.SearchValue);

  }

  getDealerContractors() {
    this.apiService.GetApi(null, "Dealer/GetDealerContractors").subscribe((response: any) => {
      if (response.ResponseCode == 200) {
        console.log('getdata', response.ResponseData);
        this.dealerlist = response.ResponseData;
        this.totaldata = response.ResponseData.length;
        this.groupDealersWithContractors();

      } else {
        this.toastr.error('Failed to load dealer contractors', 'Error!', {
          timeOut: 2000
        });
      }
    }, error => {
      this.toastr.error('An error occurred while fetching data', 'Error!', {
        timeOut: 2000
      });
    });
  }

  getDealerContractorsBySearch(dealerId: number, firstName: string) {
    const requestData = {
      DealerId: dealerId,
      FirstName: firstName
    };

    this.apiService.PostApi(requestData, "Dealer/GetDealerContractorsBySearch").subscribe((response: any) => {
      if (response.ResponseCode == 200) {
        console.log('searchdata', response.ResponseData);
        this.dealerlist = response.ResponseData;
        this.totaldata = response.ResponseData.length;
        this.groupDealersWithContractors();
      } else {
        this.toastr.error('Failed to load dealer contractors by search', 'Error!', {
          timeOut: 2000
        });
      }
    }, error => {
      this.toastr.error('An error occurred while fetching data', 'Error!', {
        timeOut: 2000
      });
    });
  }
  ///////////////////////
  getDealerWiseContractorReport(pageNumber: number, pageSize: number, fromDate: string, toDate: string, searchValue: string) {
    const formattedFromDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : '2022-01-01';
    const formattedToDate = toDate ? moment(toDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    const requestData = {
      pageNumber: pageNumber,
      pageSize: pageSize,
      fromDate: formattedFromDate,
      toDate: formattedToDate,
      searchValue: searchValue || ''
    };

    this.apiService.PostApi(requestData, "Report/DealerWiseContractorReportMob").subscribe((response: any) => {
      if (response.ResponseCode === 200) {
        console.log('API Response:', response.ResponseData);
        this.groupedDealers = response.ResponseData; // Assign the API response directly
        this.totaldata = response.TotalCount;
        if (this.pageSizeOptions.indexOf(this.totaldata) === -1) {
          this.pageSizeOptions = [...this.pageSizeOptions, this.totaldata];
        }
      } else {
        this.toastr.error('No Record Found between dates', 'Error!', { timeOut: 2000 });
      }
    }, error => {
      this.toastr.error('An error occurred while fetching data', 'Error!', { timeOut: 2000 });
    });
  }


  groupDealersWithContractors() {
    const grouped = this.dealerlist.reduce((acc, dealer) => {
      // Find the sales entry in the accumulator
      const existingSales = acc.find(s => s.SalesId === dealer.SalesId);

      if (existingSales) {
        // Find the dealer entry under the sales
        const existingDealer = existingSales.Dealers.find(d => d.DealerId === dealer.DealerId);

        if (existingDealer) {
          // Add contractor to the existing dealer
          existingDealer.Contractors.push({
            ContractorId: dealer.ContractorId,
            ContractorFirstName: dealer.ContractorFirstName,
            ContractorMobile: dealer.ContractorMobile
          });
        } else {
          // Add a new dealer under the sales
          existingSales.Dealers.push({
            DealerId: dealer.DealerId,
            DealerName: dealer.DealerFirstName,
            DealerMobile: dealer.DealerMobile,
            Contractors: [{
              ContractorId: dealer.ContractorId,
              ContractorFirstName: dealer.ContractorFirstName,
              ContractorMobile: dealer.ContractorMobile
            }]
          });
        }
      } else {
        // Add a new sales entry
        acc.push({
          SalesId: dealer.SalesId,
          salerName: dealer.SalerName,
          Dealers: [{
            DealerId: dealer.DealerId,
            DealerName: dealer.DealerFirstName,
            DealerMobile: dealer.DealerMobile,
            Contractors: [{
              ContractorId: dealer.ContractorId,
              ContractorFirstName: dealer.ContractorFirstName,
              ContractorMobile: dealer.ContractorMobile
            }]
          }]
        });
      }
      return acc;
    }, []);
    this.groupedDealers = grouped;
  }



  DownloadScanReport() {
    debugger;
    const formattedFromDate = this.fromDate ? moment(this.fromDate).format('YYYY-MM-DD') : '2022-01-01';
    const formattedToDate = this.toDate ? moment(this.toDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');

    let obj = {
      pageNumber: this.formval.Page ? this.formval.Page : 1,
      pageSize: this.totaldata ? this.totaldata : 10,
      searchValues: this.formval.SearchValue ? this.formval.SearchValue : '',
      fromDate: formattedFromDate,
      toDate: formattedToDate
    }
    console.log('parameter obj', obj);

    if (moment(this.formval.fromdate).isAfter(this.formval.todate)) {
      this.toastr.warning('From Date should not be greater than To Date!', 'Warning!', {
        timeOut: 3000
      });
    }
    else {
      this.show = true;
      this.formval.PageSize = this.totaldata[0];
      this.formval.Page = this.formval.pageNumber;
      console.log('postobj2', obj);
      this.apiService.PostApi(obj, "Report/DealerWiseContractorReport").subscribe((response: any) => {
        debugger
        if (response.ResponseCode == 200) {
          console.log('dataexcel', response.ResponseData);
          this.scanreportlistexcel = response.ResponseData;
          this.reportExcelPassbook = this.reportExcelPassbook.slice();
          this.scanreportlistexcel.forEach(o => {
            this.reportExcelPassbook.push(
              {
                Saler_Name: o.salerName,
                Saler_Code: o.SalesId,

                Dealer_Name: o.DealerName,
                Dealer_Code: o.DealerId,
                Dealer_Mobile: o.DealerMobile,
                Dealer_Email: o.DealerEmail,
                Dealer_JoinDate: o.CreatedDate,

                Contractor_Name: o.ContractorName,
                Contractor_Code: o.ContractorId,
                Contractor_Mobile: o.ContractorMobile,
                Contractor_Email: o.ContractorEmail,
              });
          });
          this.exportAsXLSX(this.reportExcelPassbook);
        }
        else {
          this.toastr.warning('There is no file to download', 'Warning!', {
            timeOut: 1000
          });
        }
      },
        err => {
          this.show = false;
          this.totaldata = 0;
        }
      )
      this.show = false;
    }
    this.formval.Page = 1;
    this.formval.PageSize = 5;
  }

  exportAsXLSX(myreport: any): void {
    this.excelService.exportAsExcelFile(this.reportExcelPassbook, 'DealerwiseReport_' + this.formval.ScanStatus + '_' + moment(this.formval.fromdate, "DD-MMM-YYYY").format("DD-MMM-YYYY") + '_to_' + moment(this.formval.todate, "DD-MMM-YYYY").format("DD-MMM-YYYY"));
    this.formval.PageSize = 5;
  }
  setDates(): any {
    var date = new Date();

    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var currentDay = date.getDate();

    this.formval.fromdate = moment(firstDay, "DD-MMM-YYYY").format("DD-MMM-YYYY");
    this.formval.todate = moment(currentDay, "DD-MMM-YYYY").format("DD-MMM-YYYY");
  }


  getOSearchvalue(user: UserPage): any {
    this.show = true;
    this.pagesUser.UserType = 1;

    this.apiService.PostApi(this.pagesUser, "Setting/GetAllSettings").subscribe((response: any) => {
      debugger;
      if (response.ResponseCode == "200") {
        //  (response)
        this.settingslist = response.ResponseData;
        this.totaldata = response.TotalCount;
        if (this.totaldata < parseInt(this.pagesUser.pageSize)) {
          this.currentPage = 1;
        }
      }
      else {
        this.settingslist = null;
        this.show = false;
      }
    }, err => {
      this.settingslist = null;
      this.show = false;
    });
    this.show = false;
  }


  // pageChanged(event: PageChangedEvent): void {
  //   //  alert(event.page)
  //     const startItem = (event.page - 1) * event.itemsPerPage;
  //     const endItem = event.page * event.itemsPerPage;
  //     this.pagesUser.page=event.page;
  //     this.getOrganisation(this.pagesUser);
  //    //  (this.users)
  //    this.currentPage=event.page+1;
  //   }
  pageChanged(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.formval.Page = event.page;
    this.getDealerWiseContractorReport(this.formval.Page, this.formval.PageSize, this.fromDate, this.toDate, this.formval.SearchValue);
    this.currentPage = event.page + 1;
  }

  // pageChanged(event: PageChangedEvent): void {
  //   this.formval.Page = event.page;
  //   this.getDealerWiseContractorReport(this.formval.Page, this.formval.PageSize, this.fromDate, this.toDate, this.formval.SearchValue);
  // }

  onpagechange() {
    this.formval.Page = 1;
    this.getDealerWiseContractorReport(this.formval.Page, this.formval.PageSize, this.fromDate, this.toDate, this.formval.SearchValue);
  }
  SearchValue(Page: any, PageSize: any, fromDate: string, toDate: string, SearchValue: any) {
    throw new Error('Method not implemented.');
  }

  ShowErrorList(template: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true, class: 'modal-lg' };
    this.modalRef3 = this.modalService.show(template, config);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  alphaOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return true;
    }
    return false;
  }
  openModal(template: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true, class: 'modal-lg' };
    (template);
    this.modalRef = this.modalService.show(template, config);
  }

}
